// Tarjeta de KPI moderna: icono en teja de color suave, cifra grande y etiqueta.
import React from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const TONES = {
  primary: { bg: "rgba(251,181,63,0.14)", color: "#D97706" },
  navy: { bg: "rgba(34,51,107,0.10)", color: "#22336B" },
  info: { bg: "rgba(26,115,232,0.10)", color: "#1A73E8" },
  success: { bg: "rgba(67,160,71,0.12)", color: "#2E7D32" },
  error: { bg: "rgba(229,57,53,0.10)", color: "#D32F2F" },
};

export default function StatCard({ icon: Icon, label, value, hint, tone = "primary", onClick }) {
  const t = TONES[tone] || TONES.primary;

  return (
    <Card
      elevation={0}
      onClick={onClick}
      sx={{
        p: 2.5,
        height: "100%",
        borderRadius: 3,
        border: "1px solid",
        borderColor: "grey.200",
        transition: "border-color .15s ease, background .15s ease",
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick ? { borderColor: t.color, bgcolor: "grey.100" } : undefined,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "12px",
            bgcolor: t.bg,
            color: t.color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {Icon && <Icon sx={{ fontSize: 26 }} />}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h4" fontWeight={700} lineHeight={1.15} noWrap>
            {value}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight={600}
            textTransform="uppercase"
            letterSpacing="0.04em"
            noWrap
            display="block"
          >
            {label}
          </Typography>
          {hint && (
            <Typography variant="caption" color="text.secondary" noWrap display="block">
              {hint}
            </Typography>
          )}
        </Box>
      </Stack>
    </Card>
  );
}

StatCard.propTypes = {
  icon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hint: PropTypes.string,
  tone: PropTypes.oneOf(["primary", "navy", "info", "success", "error"]),
  onClick: PropTypes.func,
};
